{
  "cms.schedule.rowMarker.publish": "Publishes {aika}",
  "cms.schedule.rowMarker.publishEdits": "Changes publish {aika}",
  "cms.schedule.rowMarker.unpublish": "Unpublishes {aika}"
}
